import { render, staticRenderFns } from "./all-trajects.vue?vue&type=template&id=567ff8bc"
import script from "./all-trajects.vue?vue&type=script&lang=js"
export * from "./all-trajects.vue?vue&type=script&lang=js"
import style0 from "./all-trajects.vue?vue&type=style&index=0&id=567ff8bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports